import { api as gridApi} from './qplTestsViewGridActions';
import {createLabelHelper} from 'infrastructure/js/utils/labelHelper';
import {api as messageDialogApi} from '../../MessageDialog/messageDialogActions';
import * as qplsService from '../../../services/Qpls/qplsService';
import Network from 'infrastructure/js/modules/network';
/////////////////////////////////////////
// ACTION TYPES - PUBLIC, FOR REDUCERS
export const actionTypes = {
};

////////////////////////////////////////////////////////////////
// PLAIN ACTION CREATORS - PRIVATE, FOR LOCAL DISPATCH ONLY
const actions = {
};

/////////////////////////////////////////////////////
// METHODS FOR JSX PROPS - PUBLIC, ALL THUNK TYPE
export let jsxActions = {};

jsxActions.init = function(shouldRefreshGrid) {
  return function(dispatch, getState) {
    api.load(dispatch, getState)(shouldRefreshGrid);
  }
};

jsxActions.reload = function() {
  return function(dispatch, getState) {
    api.reload(dispatch, getState)();
  }
};

jsxActions.clearFilters = function () {
  return function (dispatch, getState) {
    gridApi.clearFilters(dispatch, getState)();
  }
};

jsxActions.removeQplTests = function(data) {
  return function(dispatch, getState) {
    api.removeQplTests(dispatch, getState)(data);
  }
};


/////////////////////////////////////////////////////////////////////////
// API METHODS - PUBLIC, FOR OTHER ACTION MODULES (and internal use)
export let api = {};

api.load = function(dispatch, getState) {
  return function(shouldRefreshGrid) {
    if (shouldRefreshGrid) {
      gridApi.reload(dispatch, getState)();
    }
  }
};

api.reload = function(dispatch, getState) {
  return function() {
      gridApi.reload(dispatch, getState)();
  }
};

api.removeQplTests = function(dispatch, getState) {
  return function (data) {

    let labels = createLabelHelper('mat.administration.matsettings.qpls.view.');
    let confirmationConfig = {
      message: labels.get('remove.confirmation.message', '', {count: data.length}),
      cancelHandler: messageDialogApi.close(dispatch, getState),
      submitHandler: () => api.doRemoveQplTests(dispatch, getState)(data),
    };

    messageDialogApi.showConfirmation(dispatch, getState)(confirmationConfig);
  }
};

api.doRemoveQplTests = function(dispatch, getState) {
  return function(data) {
    messageDialogApi.close(dispatch, getState)();

    const testsIds = data?.map(item => item.id);

    qplsService.removeQplTests({testsIds}).then((response) => {
      if (!Network.isResponseValid(response)) {
        console.error('Failed to remove QPL tests', response);
        messageDialogApi.responseError(dispatch, getState)(response);
        return {success: false};
      }
      gridApi.reload(dispatch, getState)();
    });
  }
};




/////////////////////////////////////////////////////////////////////////
// PRIVATE HELPERS
